import { FormFieldTypes } from "../../../../components/finalForms/libs/data/formFieldType";
import { validationTypes } from "../../../../components/finalForms/libs/data/ValidationTypes";

export const PasswordForm = {
  name: "Password Form",
  initialState: { password: "", userId: "" },
  section: [
    {
      sectionId: 'passwordForm',
      title: "password Form",
      row: {},
      style: {
        sectionStyle: "col-lg-12",
      },
      wrapperTemplate: <div className="form-card row"></div>,
      fields: [
        {
          id: "Password",
          label: "New Password",
          Field_Name: "new password",
          fieldType: FormFieldTypes.PASSWORD,
          dataField: "password",
          fieldSetting: {
            placeholder: "Please Enter New Password",
            allowSpace: false,
            isDisable: false,
          },
          style: {
            containerCss: "col-md-6 mb-2 validation-error-icon",
          },
          validation: [
            { type: validationTypes.PASSWORD },
          ],
        },
        {
          id: "ConfirmPassword",
          label: "Confirm Password",
          Field_Name: "confirm new password",
          fieldType: FormFieldTypes.PASSWORD,
          dataField: "Confirmpassword",
          fieldSetting: {
            placeholder: "Please Re-enter New Password",
            allowSpace: false,
            isDisable: false,
          },
          style: {
            containerCss: "col-md-6 mb-2 validation-error-icon",
          },
          validation: [
            { type: validationTypes.REQUIRE },
            { type: validationTypes.COMPARE, compareEle: 'password' },
          ],
        },
      ]
    }
  ]
}

export default PasswordForm;
